const TIER_COLORS = {
  light_touch: "#00DC78",
  mid_touch: "#5AC8D8",
  heavy_touch: "#FFB347",
  heavy_turn: "#FF5C5C",
};

export const tierColor = (tier) => TIER_COLORS[tier] || "#A0A0A0";

export const TierBadge = ({ cls, compact = false }) => {
  if (!cls) return null;
  const c = tierColor(cls.tier);
  return (
    <div className={`insp-tier ${compact ? "insp-tier--compact" : ""}`} style={{ borderColor: c }} data-testid="insp-tier-badge">
      <span className="insp-tier__dot" style={{ background: c }} />
      <span className="insp-tier__label" style={{ color: c }} data-testid="insp-tier-label">{cls.label}</span>
      <span className="insp-tier__window">{cls.window}</span>
      {!compact && cls.variance_required && <span className="insp-tier__flag" data-testid="insp-tier-variance">CEO variance call</span>}
      {cls.precondition_hold && <span className="insp-tier__flag" data-testid="insp-tier-clear-unit-hold">Clear Unit hold · appliances on site</span>}
      {cls.nspire_hold && <span className="insp-tier__flag" data-testid="insp-tier-nspire-hold">NSPIRE 24h life-safety hold</span>}
    </div>
  );
};
